module.exports = __webpack_public_path__ + "static/media/icon_213.a9a71889.svg";